module.exports = __webpack_public_path__ + "img/tiyou.95a9b3c6.png";